import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
// import { useHistory } from 'react-router';
import { makeStyles } from '@material-ui/core/styles';
import axios from 'axios';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CommonConfig } from '../../config/common-config';
import { useSelector } from 'react-redux';
import Tooltip from '@material-ui/core/Tooltip';
import LoaderPopUp from '../../components/loaderpopup/loader';
import { setLoginSuccessUserDetails } from '../../modules/users/login/store/actions/index';
import SuccessPopUp from '../../components/loaderpopup/success';

const useStyles = makeStyles((theme) => ({
    button: {
        margin: '0px !important',
        background: '#4c4fa6 !important',
        color: '#fff !important',
        padding: '6px 48px !important',
        fontFamily: 'Rubik',
        textTransform: 'none !important',
    },
    buttonView: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 10px',
        letterSpacing: 'normal',
        width: '35%',
        margin: '0px',
    },
    disableBtn: {
        color: '#bbb !important',
        background: '#cecece !important',
        padding: '6px 40px !important',
        fontFamily: 'Rubik',
        textTransform: 'none !important',
    },
    namelabel: {
        border: '1px solid grey',
        padding: '8px 18px',
        width: '24%',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        marginRight: '14px',
        marginTop: '15px',
        borderRadius: '6px',
        cursor: 'pointer',
    },
    disableButton: {
        color: '#bbb !important',
        background: '#cecece !important',
        padding: '6px 40px !important',
        fontFamily: 'Rubik',
        textTransform: 'none !important',
        padding: '6px 48px !important',
        margin: '0px !important',
        pointerEvents: 'none !important',
    },
}));

export default function FileModal({ openModal, openCorpModal, handleDialogClose, handleLogout }) {
    // const history = useHistory();
    const classes = useStyles();
    const dispatch = useDispatch({});

    const [handleOpen, setHandleOpen] = useState(false);
    const [clearData, setClearData] = useState('');
    const [isfileInvalid, setIsfileInvalid] = useState('');
    const [selectedFileData, setSelectedFileData] = useState(null);
    const [filename, setFilename] = useState('');
    const [uploadSuccessfully, setUploadSuccessfully] = useState('');
    const [isDisable, setIsDisable] = useState(true);
    const [URLValuePan, setURLValuePan] = useState();
    const [URLValueAadhaar, setURLValueAadhaar] = useState();
    const [URLValueGSTIN, setURLValueGSTIN] = useState();
    const [attachedFilePan, setAttachedFilePan] = useState('');
    const [attachedFileAadhaar, setAttachedFileAadhaar] = useState('');
    const [attachedFileGSTIN, setAttachedFileGSTIN] = useState('');
    const [fileType, setFileType] = useState('');

    const [handleOpenNew, setHandleOpenNew] = useState(false);
    const [clearDataNew, setClearDataNew] = useState('');
    const [isfileInvalidNew, setIsfileInvalidNew] = useState('');
    const [selectedFileDataNew, setSelectedFileDataNew] = useState(null);
    const [URLValueCorpPan, setURLValueCorpPan] = useState();
    const [URLValueCorpGSTIN, setURLValueCorpGSTIN] = useState();
    const [attachedCorpFilePan, setAttachedCorpFilePan] = useState('');
    const [attachedCorpFileGSTIN, setAttachedCorpFileGSTIN] = useState('');
    const [uploadSuccessfullyNew, setUploadSuccessfullyNew] = useState('');
    const [isDisableNew, setIsDisableNew] = useState(true);
    const [corpFilename, setCorpFilename] = useState('');
    const [fileCorpType, setFileCorpType] = useState('');

    const [showLoaderSave, setShowLoaderSave] = useState(false);

    // const [openCorpModal, setOpenCorpModal] = React.useState(false);

    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName.tennantName);
    const tennantData = useSelector((state) => state.loginsuccessreducer.tennantName);
    const companyName = tennantData.companyName;
    const userToken = tempToken && tempToken.data.token;
    const gstFiles = tempToken && tempToken.data && tempToken.data.gstFiles;
    const aadharFiles = tempToken && tempToken.data && tempToken.data.aadharFiles;
    const panFiles = tempToken && tempToken.data && tempToken.data.panFiles;
    const [checkPan, setCheckPan] = useState(false);
    const [checkAadhaar, setCheckAadhaar] = useState(false);
    const [checkGst, setCheckGst] = useState(false);
    const bearerToken = `Bearer ${userToken}`;
    const axiosConfig = {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            Authorization: bearerToken,
        },
    };
    const [success, setSuccess] = useState(false);

    useEffect(() => {
        if (panFiles) {
            setCheckPan(true);
        }
        if (aadharFiles) {
            setCheckAadhaar(true);
        }
        if (gstFiles) {
            setCheckGst(true);
        }
    }, []);

    const handleClose = () => {
        setHandleOpen(false);
        setIsfileInvalid('');
        setUploadSuccessfully('');
    };
    const handleClick = (value) => {
        setFileType(value);
        setHandleOpen(true);
        setClearData('');
        setFilename('');
        setIsDisable(true);
    };
    const toInputUppercase = (e) => {
        e.target.value = ('' + e.target.value).toUpperCase();
    };
    const isFileUpload = (event, selectorFiles) => {
        if (selectorFiles) {
            const pattern = new RegExp('^.+.(doc|docx|xlsx|xls|csv|png|jpeg|jpg|pdf|zip)$');
            setFilename(selectorFiles[0].name);
            if (pattern.test(selectorFiles[0].name)) {
                setIsfileInvalid('');
                setIsDisable(false);
                if (selectorFiles[0].size / 1024 > 1024 * 10) {
                    setIsfileInvalid('Please select the file size less than 10MB');
                    setIsDisable(true);
                } else {
                    setSelectedFileData(selectorFiles[0]);
                }
            } else {
                setIsfileInvalid('Please select valid file format i.e xlsx/xls/csv');
                setIsDisable(true);
            }
        }
    };
    const fileUpload = () => {
        const data = new FormData();
        data.append('file', selectedFileData);
        axios
            .post(`${CommonConfig.dev.baseUrl}/api/auth/s3upload/${tennantDetails}/111/myimage`, data, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                if (response.data) {
                    const filename = response.data.substring(response.data.lastIndexOf('/') + 1);
                    if (fileType === 'Pan') {
                        setURLValuePan(response.data);
                        setAttachedFilePan(filename);
                        setCheckPan(true);
                    }
                    if (fileType === 'Aadhaar') {
                        setURLValueAadhaar(response.data);
                        setAttachedFileAadhaar(filename);
                        setCheckAadhaar(true);
                    }
                    if (fileType === 'GSTIN') {
                        setURLValueGSTIN(response.data);
                        setAttachedFileGSTIN(filename);
                        setCheckGst(true);
                    }
                    setUploadSuccessfully('Uploaded a file successfully');
                    setTimeout(() => {
                        handleClose();
                    }, 500);
                }
            })
            .catch((error) => {
                if (error.response.data) {
                    setIsDisable(true);
                }
            });
    };

    const handleSubmit = () => {
        setShowLoaderSave(true);
        let data = {
            panFiles: URLValuePan,
            gstFiles: URLValueGSTIN,
            aadharFiles: URLValueAadhaar,
            tennantName: tennantDetails,
        };

        //console.log('CommonConfig.dev.baseUrl1', CommonConfig.dev.baseUrl)

        axios
            .put(`${CommonConfig.dev.baseUrl}/api/auth/s_uclient_Ind/uploadfile`, data, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                if (response) {
                    tempToken.data.panFiles = panFiles || URLValuePan ? true : false;
                    tempToken.data.aadharFiles = aadharFiles || URLValueAadhaar ? true : false;
                    tempToken.data.gstFiles = gstFiles || URLValueGSTIN ? true : false;
                    let result = tempToken;
                    dispatch(setLoginSuccessUserDetails({ result }));
                    setShowLoaderSave(false);
                    setTimeout(() => {
                        handleDialogClose();
                    }, 1500);
                    setTimeout(() => {
                        setSuccess(true);
                    }, 2000);
                    setTimeout(() => {
                        setSuccess(false);
                    }, 4000);
                }
            })
            .catch((error) => {});
    };

    const handleCorpSubmit = () => {
        let data = {
            panFiles: URLValueCorpPan,
            gstFiles: URLValueCorpGSTIN,
            tennantName: tennantDetails,
            companyName: companyName,
        };

        //console.log('CommonConfig.dev.baseUrl1', CommonConfig.dev.baseUrl)

        axios
            .put(`${CommonConfig.dev.baseUrl}/api/auth/ultimate_corp_client/uploadfile`, data, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                if (response) {
                    tempToken.data.panFiles = panFiles || URLValueCorpPan ? true : false;
                    tempToken.data.gstFiles = gstFiles || URLValueCorpGSTIN ? true : false;
                    let result = tempToken;
                    dispatch(setLoginSuccessUserDetails({ result }));
                    setShowLoaderSave(true);
                    setTimeout(() => {
                        setShowLoaderSave(false);
                    }, 1500);
                    setTimeout(() => {
                        setShowLoaderSave(false);
                        handleDialogClose();
                    }, 1500);
                    setTimeout(() => {
                        setSuccess(true);
                    }, 2000);
                    setTimeout(() => {
                        setSuccess(false);
                    }, 4000);
                }
            })
            .catch((error) => {
                //console.log(error)
            });
    };

    const handleCloseNew = () => {
        setHandleOpenNew(false);
        setIsfileInvalidNew('');
        setUploadSuccessfullyNew('');
        setCorpFilename('');
        // setAttachedCorpFilePan('');
        // setAttachedCorpFileAadhaar('');
        setIsDisableNew(true);
    };
    const handleClickNew = (value) => {
        setFileCorpType(value);
        setHandleOpenNew(true);
        setClearDataNew('');
        setUploadSuccessfullyNew('');
    };

    const isFileUploadNew = (event, selectorFiles) => {
        if (selectorFiles) {
            const pattern = new RegExp('^.+.(doc|docx|xlsx|xls|csv|png|jpeg|jpg|pdf|zip)$');
            setCorpFilename(selectorFiles[0].name);
            if (pattern.test(selectorFiles[0].name)) {
                setIsfileInvalidNew('');
                setIsDisableNew(false);
                if (selectorFiles[0].size / 1024 > 1024 * 10) {
                    setIsfileInvalidNew('Please select the file size less than 10MB');
                    setIsDisableNew(true);
                } else {
                    setSelectedFileDataNew(selectorFiles[0]);
                }
            } else {
                setIsfileInvalidNew('Please select valid file format i.e xlsx/xls/csv');
                setIsDisableNew(true);
            }
        }
    };

    const fileUploadNew = () => {
        const data = new FormData();

        data.append('file', selectedFileDataNew);
        //console.log('Udhay', selectedFileDataNew);
        axios
            .post(`${CommonConfig.dev.baseUrl}/api/auth/s3upload/${tennantDetails}/111/myimage`, data, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                if (response.data) {
                    const filename = response.data.substring(response.data.lastIndexOf('/') + 1);
                    if (fileCorpType === 'Pan') {
                        setAttachedCorpFilePan(filename);
                        setURLValueCorpPan(response.data);
                        setCheckPan(true);
                    }
                    if (fileCorpType === 'GSTIN') {
                        setAttachedCorpFileGSTIN(filename);
                        setURLValueCorpGSTIN(response.data);
                        setCheckGst(true);
                    }
                    setUploadSuccessfullyNew('Uploaded a file successfully');
                    setTimeout(() => {
                        handleCloseNew();
                    }, 500);
                }
            })
            .catch((error) => {
                if (error.response.data) {
                    setIsDisableNew(true);
                }
            });
    };

    return (
        <div>
            {success ? <SuccessPopUp open={success} showSuccess={success} handleClose={handleClose} title="Uploaded successfully" /> : null}

            <Dialog
                // onClose={handleDialogClose}
                PaperProps={{
                    className: 'QandADailogBox',
                    style: { padding: '20px', width: '60%' },
                }}
                aria-labelledby="form-dialog-title"
                open={openModal}
                disableBackdropClick
            >
                <h3 className="filename" style={{ padding: '0px 11px', marginBottom: '2px' }}>
                    Please upload your documents to proceed further
                </h3>
                <h4 className="filename" style={{ padding: '0px 11px', color: 'red', marginTop: '0px' }}>
                    {!checkPan && !checkAadhaar && !checkGst ? '*Pan, Aadhaar and GSTIN attachments are mandatory' : null}
                    {!checkPan && !checkAadhaar && checkGst ? '*Pan and Aadhaar attachments are mandatory' : null}
                    {!checkPan && checkAadhaar && !checkGst ? '*Pan and GSTIN attachments are mandatory' : null}
                    {!checkPan && checkAadhaar && checkGst ? '*Pan attachments are mandatory' : null}
                    {checkPan && !checkAadhaar && checkGst ? '*Aadhaar attachments are mandatory' : null}
                    {checkPan && checkAadhaar && !checkGst ? '*GSTIN attachments are mandatory' : null}
                </h4>
                <div style={{ alignItems: 'center', margin: '5px 0px 20px 0px' }}>
                    <div style={{ display: 'flex', placeContent: aadharFiles || panFiles ? 'flex-start' : 'space-evenly' }}>
                        {!aadharFiles ? (
                            <Button
                                onClick={() => handleClick('Aadhaar')}
                                variant="outlined"
                                color="primary"
                                size="small"
                                className={classes.buttonView}
                            >
                                Attach Aadhaar card
                            </Button>
                        ) : null}
                        {!panFiles ? (
                            <Button
                                onClick={() => handleClick('Pan')}
                                variant="outlined"
                                color="primary"
                                size="small"
                                className={classes.buttonView}
                            >
                                Attach PAN card
                            </Button>
                        ) : null}
                    </div>
                </div>
                {!gstFiles ? (
                    <Button
                        onClick={() => handleClick('GSTIN')}
                        variant="outlined"
                        color="primary"
                        size="small"
                        className={classes.buttonView}
                    >
                        Attach GSTIN
                    </Button>
                ) : null}

                <div style={{ alignItems: 'start', margin: '5px 0px 20px 0px' }}>
                    <div style={{ display: 'flex', placeContent: 'flex-start', marginLeft: '10px' }}>
                        {attachedFilePan ? (
                            <Tooltip title={attachedFilePan}>
                                <span className={classes.namelabel}>{attachedFilePan}</span>
                            </Tooltip>
                        ) : null}
                        {attachedFileAadhaar ? (
                            <Tooltip title={attachedFileAadhaar}>
                                <span className={classes.namelabel}>{attachedFileAadhaar}</span>
                            </Tooltip>
                        ) : null}
                        {attachedFileGSTIN ? (
                            <Tooltip title={attachedFileGSTIN}>
                                <span className={classes.namelabel}>{attachedFileGSTIN}</span>
                            </Tooltip>
                        ) : null}
                    </div>
                </div>

                <DialogActions className="paddingBtm" style={{ justifyContent: 'flex-start' }}>
                    <Button
                        className={checkPan && checkAadhaar && checkGst ? classes.button : classes.disableButton}
                        disabled={!checkPan && !checkAadhaar && !checkGst}
                        onClick={handleSubmit}
                        variant="contained"
                        component="label"
                        color="default"
                    >
                        Save
                    </Button>
                    <Button className={classes.button} onClick={handleLogout} variant="contained" component="label" color="default">
                        Logout
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                // onClose={handleDialogClose}
                PaperProps={{
                    className: 'QandADailogBox',
                    style: { padding: '20px', width: '60%' },
                }}
                aria-labelledby="form-dialog-title"
                open={openCorpModal}
                disableBackdropClick
            >
                <h3 className="filename" style={{ padding: '0px 11px' }}>
                    Please upload your documents to proceed further
                </h3>
                <h4 className="filename" style={{ padding: '0px 11px', color: 'red', marginTop: '0px' }}>
                    {!checkPan && !checkGst ? '*Pan and GSTIN attachments are mandatory' : null}
                    {!checkPan && checkGst ? '*Pan attachments are mandatory' : null}
                    {checkPan && !checkGst ? '*GSTIN attachments are mandatory' : null}
                </h4>
                <div style={{ alignItems: 'center', margin: '5px 0px 8px 0px' }}>
                    <div style={{ display: 'flex', placeContent: 'space-evenly' }}>
                        {!panFiles ? (
                            <Button
                                onClick={() => handleClickNew('Pan')}
                                variant="outlined"
                                color="primary"
                                size="small"
                                className={classes.buttonView}
                            >
                                Attach Pan card
                            </Button>
                        ) : null}

                        {/* <Button
                            onClick={() => handleClickNew('Aadhaar')}
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.buttonView}
                        >
                            Attach PAN card
                                                        </Button> */}
                        {!gstFiles ? (
                            <Button
                                onClick={() => handleClickNew('GSTIN')}
                                variant="outlined"
                                color="primary"
                                size="small"
                                className={classes.buttonView}
                            >
                                Attach GSTIN
                            </Button>
                        ) : null}
                    </div>
                </div>

                {/* <Button
                    onClick={() => handleClickNew('GSTIN')}
                    variant="outlined"
                    color="primary"
                    size="small"
                    className={classes.buttonView}
                >
                    Attach GSTIN
                                                        </Button> */}

                <div style={{ alignItems: 'start', margin: '5px 0px 20px 0px' }}>
                    <div style={{ display: 'flex', placeContent: 'flex-start', marginLeft: '10px' }}>
                        {attachedCorpFilePan ? (
                            <Tooltip title={attachedCorpFilePan}>
                                <span className={classes.namelabel}>{attachedCorpFilePan}</span>
                            </Tooltip>
                        ) : null}
                        {attachedCorpFileGSTIN ? (
                            <Tooltip title={attachedCorpFileGSTIN}>
                                <span className={classes.namelabel}>{attachedCorpFileGSTIN}</span>
                            </Tooltip>
                        ) : null}
                        {/* {attachedFileGSTIN ?
                            <Tooltip title={attachedFileGSTIN}>
                                <span className={classes.namelabel}>{attachedFileGSTIN}</span>
                            </Tooltip> : null} */}
                    </div>
                </div>

                <DialogActions className="paddingBtm" style={{ justifyContent: 'flex-start' }}>
                    <Button
                        className={checkPan && checkGst ? classes.button : classes.disableButton}
                        onClick={handleCorpSubmit}
                        variant="contained"
                        component="label"
                        color="default"
                    >
                        Save
                    </Button>
                    <Button className={classes.button} onClick={handleLogout} variant="contained" component="label" color="default">
                        Logout
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                onClose={handleClose}
                PaperProps={{
                    className: 'QandADailogBox',
                    style: { padding: '20px' },
                }}
                aria-labelledby="form-dialog-title"
                open={handleOpen}
                clear={clearData}
            >
                <DialogTitle id="form-dialog-title">
                    Upload File
                    {/* <IconButton
                    aria-label="close"
                    className={classes.closeButton}
                    onClick={handleClose}
                >
                    <CloseIcon />
                </IconButton> */}
                </DialogTitle>
                <DialogContent style={{ textAlign: 'center' }}>
                    <Button className="btnOrange" variant="outlined" component="label" color="default">
                        <i className="btnIcon">
                            <FontAwesomeIcon icon={faPlus} />
                        </i>{' '}
                        Add File
                        <input
                            onChange={(e) => isFileUpload(e, e.target.files)}
                            type="file"
                            style={{ display: 'none' }}
                            accept=".jpeg,.png,.csv,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf,image/*"
                        />
                    </Button>
                    <p className="fileName">{filename}</p>
                </DialogContent>
                <p className="fileNameGreen">{uploadSuccessfully}</p>
                <DialogActions className="paddingBtm txtCenter">
                    <Button
                        className={isDisable ? classes.disableBtn : 'btnBluepop'}
                        onClick={fileUpload}
                        variant="contained"
                        disabled={isDisable}
                        component="label"
                        color="default"
                    >
                        Upload
                    </Button>
                    <Button
                        className="btnBluepop"
                        disabled={uploadSuccessfully.length}
                        onClick={handleClose}
                        variant="contained"
                        component="label"
                        color="default"
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                onClose={handleCloseNew}
                PaperProps={{
                    className: 'QandADailogBox',
                    style: { padding: '20px' },
                }}
                aria-labelledby="form-dialog-title"
                open={handleOpenNew}
                clear={clearDataNew}
            >
                <DialogTitle id="form-dialog-title">
                    Upload File
                    {/* <IconButton
                                                            aria-label="close"
                                                            className={classes.closeButton}
                                                            onClick={handleCloseNew}
                                                        >
                                                            <CloseIcon />
                                                        </IconButton> */}
                </DialogTitle>
                <DialogContent style={{ textAlign: 'center' }}>
                    <Button className="btnOrange" variant="outlined" component="label" color="default">
                        <i className="btnIcon">
                            <FontAwesomeIcon icon={faPlus} />
                        </i>{' '}
                        Add File
                        <input
                            onChange={(e) => isFileUploadNew(e, e.target.files)}
                            type="file"
                            style={{ display: 'none' }}
                            accept=".jpeg,.png,.csv,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf,image/*"
                        />
                    </Button>
                    <p className="fileName">{corpFilename}</p>
                </DialogContent>
                <p className="fileNameGreen">{uploadSuccessfullyNew}</p>
                <DialogActions className="paddingBtm txtCenter">
                    <Button
                        className={isDisableNew ? 'disableBtn' : 'btnBluepop'}
                        onClick={fileUploadNew}
                        variant="contained"
                        disabled={isDisableNew}
                        component="label"
                        color="default"
                    >
                        Upload
                    </Button>
                    <Button
                        className="btnBluepop"
                        disabled={uploadSuccessfullyNew.length}
                        onClick={handleCloseNew}
                        variant="contained"
                        component="label"
                        color="default"
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
            {showLoaderSave ? (
                <LoaderPopUp showLoader={showLoaderSave} handleClose={handleClose} title="Please wait while saving Draft Statements" />
            ) : null}
        </div>
    );
}
